<div>
    <mat-form-field appearance="outline" class="fw-ThirdLevelNavigation_Matselect">
        <mat-select class="fw-ThirdLevelNavigation_Matselect" #menuSelect disableOptionCentering panelClass="ap-AccountPicker_Matselect">
            <ng-container *ngFor="let thirdNav of thirdNavLinks"> 
                <mat-option *ngIf="!(thirdNav.id === 'sectorindustry'); else modPageCheck" [value]="thirdNav.name" (onSelectionChange)="handleNavigation(thirdNav)">
                    <span> {{ thirdNav.name | pershingTranslate}} </span>
                </mat-option>
                <ng-template #modPageCheck>
                    <mat-option [value]="thirdNav.name" (onSelectionChange)="gotoPageEvent('/nxi/research/markets/sectorindustry/sectorindusperformance')">
                        <span> {{ thirdNav.name | pershingTranslate}} </span>
                    </mat-option>
                </ng-template>
            </ng-container>
        </mat-select>
    </mat-form-field>
</div>